import { makeAutoObservable } from 'mobx';

class AccountModel {
  id = 0;

  type = 1;

  userID = '';

  name = '';

  first_name = '';

  soname = '';

  last_name = '';

  avatar = '';

  country = 'UA';

  language = 'ru-RU';

  is_bot = 0;

  created_at = null;

  updated_at = null;

  deleted_at = null;

  constructor(account = null, autoObservable) {
    if (account) {
      this.id = account.id;
      this.type = account.type;
      this.userID = account.userID;
      this.name = account.name;
      this.first_name = account.first_name;
      this.soname = account.soname;
      this.last_name = account.last_name;
      this.avatar = account.avatar;
      this.country = account.country;
      this.language = account.language;
      this.is_bot = account.is_bot;
      this.created_at = account.created_at;
      this.updated_at = account.updated_at;
      this.deleted_at = account.deleted_at;
    }
    if (autoObservable) {
      makeAutoObservable(this);
    }
  }
}

export default AccountModel;
